// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

@Component({
    name: 'Row',
    mixins: [
        template,
    ]
})
export class Row extends Vue {

 }